import PricingPlanToDisplay from './PricingPlanToDisplay';

export default class StudioPlanToDisplay extends PricingPlanToDisplay {
	constructor( { pricingPlan, isMonthly } ) {
		super( { pricingPlan, isMonthly } );
	}

	get title() {
		return 'Studio';
	}

	get text() {
		return 'For teams and agencies that need even more capabilities.';
	}

	get minimumMembersInfo() {
		return 'Starting at 2 members';
	}

	get annualCost() {
		return ( this._pricingPlan.annualPriceCostPerMember / 12 ) || undefined;
	}

	get monthlyCost() {
		return this._pricingPlan.monthlyPriceCostPerMember;
	}

	get featuresSubstitle() {
		return 'Everything in Pro, plus';
	}

	get features() {
		return [
			'Custom branding',
			'Markup viewing permissions',
			'Collaborator group templates',
			'Assign assets',
			'Custom label templates'
		];
	}

	statusToShow( { workspace } ) {
		if ( workspace.isNullWorkspace ) {
			return this._showNoWorkspaceStatus();
		}
		if ( workspace.isSubscriptionActive ) {
			return workspace?.hasADowngradePending ? this._showDowngradeStatus()
				: this._showActiveSubscriptionStatus( workspace );
		}
		return this._showInactiveSubscriptionStatus( { workspace } );
	}

	_showActiveSubscriptionStatus( workspace ) {
		if ( !workspace.hasAPaidPlan ) return { status: 'upgrade', text: 'Buy Studio' };
		if (
			this._levelForPlan[ this.name ] === this._levelForPlan[ workspace.subscriptionPlanName ]
		) {
			if ( workspace.hasAMonthlyBillingPeriod && this.isAnnual ) {
				return { status: 'upgrade', text: 'Upgrade to Annual' };
			}

			return { status: 'stay', text: 'You are subscribed to Studio!' };
		}
		return { status: 'upgrade', text: 'Upgrade to Studio' };
	}

	_showDowngradeStatus() {
		return { status: 'cancelDowngrade', text: 'Restore Studio' };
	}
}
